import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DtoFeature, DtoPackage, DtoPackageSubCategory, DtoPreviewItem } from '../../../models/package-center.model';

@Component({
  selector: 'app-prodetails-modal',
  templateUrl: './prodetails-modal.component.html'
})
export class ProdetailsModalComponent implements OnInit {

  packageDetails = {} as DtoPackage;
  itemToPreview: {[key:string]: DtoPreviewItem[]}= {};
  singleItemPreview: boolean = false;
  title: string = ""

  constructor(@Optional() public ref: MatDialogRef<ProdetailsModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.singleItemPreview = this.data.singleItemPreview;
    this.title = this.data.title;
    
    if(this.data.singleItemPreview){
      this.packageDetails={} as DtoPackage;
      this.itemToPreview =( this.data.itemToPreview as DtoPreviewItem[]).reduce((result, sc) => 
                  {
                    const key = sc.groupName?? '-';
                    result[key] = result[key] || [];
                    result[key].push(sc);
                    return result;
                  },{} as {[key:string]: DtoPreviewItem[]});
    }
    else{
      this.itemToPreview = {};
      this.packageDetails = this.data.packageDetails;
    }
  }

  geFeatureTree(features: DtoFeature[]):{[key:string]: DtoFeature[]}{
    return features.reduce((result, sc) => 
                  {
                    const key = sc.featureSetName;
                    result[key] = result[key] || [];
                    result[key].push(sc);
                    return result;
                  },{} as {[key:string]: DtoFeature[]});
  }
  getSubcategoryTree(subCategories: DtoPackageSubCategory[]):{[key:string]: DtoPackageSubCategory[]}
  {
    return subCategories.reduce((result, sc) => 
                  {
                    const key = sc.moduleDisplayName?? '-';
                    result[key] = result[key] || [];
                    result[key].push(sc);
                    return result;
                  },{} as {[key:string]: DtoPackageSubCategory[]});
  }
  
  close(){
    this.ref.close();
  }
}
